import React from 'react';
import ReactDOM from 'react-dom';
import MaintenancePage from './components/MaintenancePage/MaintenancePage';

/*******************************
 * Maintenance mode
 *
 * Renders only the maintenance page: no router, auth, Apollo, or Bugsnag,
 * so no redirects or network requests happen on any route.
 * Restore by redeploying main.
 *******************************/

document.title = 'Maintenance';

ReactDOM.render(
    <MaintenancePage />,
    document.getElementById( 'app-root' )
);
